export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  FOUND: 302,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

export const REQUEST_TIMEOUT = {
  DEFAULT: 30000,
  UPLOAD: 300000,
  SEARCH: 10000,
  HEALTH_CHECK: 5000,
  REDIRECT_AFTER_SESSION_EXPIRED: 1000,
} as const;

export const NOTIFICATION_DURATION = {
  DEFAULT: 4.5,
  SHORT: 2,
  LONG: 10,
} as const;

export const QUERY_DEFAULTS = {
  STALE_TIME: {
    SHORT: 1 * 60 * 1000,
    MEDIUM: 5 * 60 * 1000,
    LONG: 10 * 60 * 1000,
  },
  GC_TIME: {
    SHORT: 5 * 60 * 1000,
    MEDIUM: 10 * 60 * 1000,
    LONG: 30 * 60 * 1000,
  },
} as const;
